module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('section', {
    attrs: {
      "role": "side-modal"
    }
  }, [_c('side-modal', {
    attrs: {
      "sides": _vm.navs
    },
    on: {
      "cancela": function($event) {
        return _vm.cancela()
      }
    }
  }, [_c('template', {
    slot: _vm.navs[0].identidade
  }, [_c('div', {
    staticClass: "side-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('form', [_c('div', {
    staticClass: "row row-field"
  }, [_c('div', {
    staticClass: "col-md-6 col-sm-6"
  }, [_c('field-validation', {
    attrs: {
      "label": "Estado",
      "field": "estadoModal",
      "status": _vm.errors,
      "custom-errors": _vm.apiErrors,
      "show-icon": false
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.enderecoEditado.estado),
      expression: "enderecoEditado.estado"
    }, {
      name: "validate",
      rawName: "v-validate"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "estadoModal",
      "data-vv-as": "Estado"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.enderecoEditado, "estado", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "selected": ""
    }
  }, [_vm._v("Escolha")]), _vm._v(" "), _vm._l((_vm.estados), function(estado) {
    return _c('option', {
      key: estado.id,
      domProps: {
        "value": estado.sigla
      },
      on: {
        "change": function($event) {
          return _vm.obtemMunicipios(_vm.enderecoEditado.estado, 'modal')
        }
      }
    }, [_vm._v("\n                        " + _vm._s(_vm._f("tudoMaiusculo")(estado.nome)) + "\n                      ")])
  })], 2)])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 col-sm-6"
  }, [_c('field-validation', {
    attrs: {
      "label": "Município",
      "field": "municipioModal",
      "status": _vm.errors,
      "custom-errors": _vm.apiErrors,
      "show-icon": false
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.enderecoEditado.municipio),
      expression: "enderecoEditado.municipio"
    }, {
      name: "validate",
      rawName: "v-validate"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "municipioModal",
      "data-vv-as": "Município"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.enderecoEditado, "municipio", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, function($event) {
        return _vm.limpaModal()
      }]
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "selected": ""
    }
  }, [_vm._v("Escolha")]), _vm._v(" "), _vm._l((_vm.municipios), function(municipio) {
    return _c('option', {
      key: municipio.id,
      domProps: {
        "value": municipio.id
      }
    }, [_vm._v("\n                        " + _vm._s(municipio.nome) + "\n                      ")])
  })], 2)])], 1)]), _vm._v(" "), (_vm.mostraLista) ? _c('div', {
    staticClass: "row row-field"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Logradouro")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.enderecoLista),
      expression: "enderecoLista"
    }],
    staticClass: "form-control",
    attrs: {
      "size": _vm.enderecos.length > 10 ? 10 : _vm.enderecos.length + 1
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.enderecoLista = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        return _vm.valoraLista()
      }]
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "selected": ""
    }
  }, [_vm._v("\n                        Selecione o seu logradouro ou refine sua busca\n                      ")]), _vm._v(" "), _vm._l((_vm.enderecos), function(endereco) {
    return _c('option', {
      key: _vm.enderecos.indexOf(endereco),
      domProps: {
        "value": endereco
      },
      on: {
        "dblclick": function($event) {
          return _vm.inclui()
        }
      }
    }, [_vm._v("\n                        " + _vm._s(_vm._f("tudoMaiusculo")(((endereco.logradouro.tipo) + " " + (endereco.logradouro.nome) + " - " + (endereco.bairro.nome) + " - " + (_vm.cepMasked(endereco.cep))))) + "\n                      ")])
  })], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12 col-sm-12",
    staticStyle: {
      "padding-top": "0px"
    }
  }, [_c('botao', {
    staticStyle: {
      "font-size": "12px"
    },
    attrs: {
      "estilo": "vazado-verde-dir",
      "rotulo": "Ok",
      "icone": "fa-check fa-lg"
    },
    on: {
      "clicado": function($event) {
        return _vm.inclui()
      }
    }
  }), _vm._v(" "), _c('botao', {
    staticStyle: {
      "font-size": "12px"
    },
    attrs: {
      "estilo": "vazado-cinza-dir",
      "rotulo": "Limpar",
      "icone": "fa-eraser fa-lg"
    },
    on: {
      "clicado": function($event) {
        return _vm.montaModal()
      }
    }
  })], 1)]) : _vm._e(), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.logradouroInvalido),
      expression: "logradouroInvalido"
    }],
    staticClass: "row row-field"
  }, [_c('div', {
    staticClass: "col-sm-3"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "tipoLogradouro"
    }
  }, [_vm._v("Tipo")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.enderecoEditado.tipoLogradouro),
      expression: "enderecoEditado.tipoLogradouro"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "tipoLogradouro"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.enderecoEditado, "tipoLogradouro", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "selected": ""
    }
  }, [_vm._v("Escolha")]), _vm._v(" "), _vm._l((_vm.tiposLogradouros), function(tipoLogradouro) {
    return _c('option', {
      key: tipoLogradouro.id,
      domProps: {
        "value": tipoLogradouro.descricao
      }
    }, [_vm._v("\n                          " + _vm._s(tipoLogradouro.descricao) + "\n                        ")])
  })], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "logradouroModal"
    }
  }, [_vm._v("Logradouro")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.enderecoEditado.logradouro),
      expression: "enderecoEditado.logradouro"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "logradouroModal",
      "id": "logradouroModal"
    },
    domProps: {
      "value": (_vm.enderecoEditado.logradouro)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.enderecoEditado, "logradouro", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('field-validation', {
    attrs: {
      "label": "CEP",
      "field": "cepModal",
      "status": _vm.errors,
      "custom-errors": _vm.apiErrors,
      "show-icon": false
    }
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate"
    }, {
      name: "mask",
      rawName: "v-mask",
      value: ('##.###-###'),
      expression: "'##.###-###'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.enderecoEditado.cep),
      expression: "enderecoEditado.cep"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "cepModal",
      "id": "cepModal",
      "data-vv-as": "CEP"
    },
    domProps: {
      "value": (_vm.enderecoEditado.cep)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.enderecoEditado, "cep", $event.target.value)
      }
    }
  })])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('field-validation', {
    attrs: {
      "label": "Bairro",
      "field": "bairroModal",
      "status": _vm.errors,
      "custom-errors": _vm.apiErrors,
      "show-icon": false
    }
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.enderecoEditado.bairro),
      expression: "enderecoEditado.bairro"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "bairroModal",
      "id": "bairroModal",
      "data-vv-as": "Bairro"
    },
    domProps: {
      "value": (_vm.enderecoEditado.bairro)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.enderecoEditado, "bairro", $event.target.value)
      }
    }
  })])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4 col-xs-5"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('field-validation', {
    attrs: {
      "label": "Número",
      "field": "numeroModal",
      "status": _vm.errors,
      "custom-errors": _vm.apiErrors,
      "show-icon": false
    }
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate"
    }, {
      name: "mask",
      rawName: "v-mask",
      value: ('######'),
      expression: "'######'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.enderecoEditado.numero),
      expression: "enderecoEditado.numero"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "numeroModal",
      "id": "numeroModal",
      "data-vv-as": "Número"
    },
    domProps: {
      "value": (_vm.enderecoEditado.numero)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.enderecoEditado, "numero", $event.target.value)
      }
    }
  })])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-2 col-xs-2"
  }, [_c('div', {
    staticClass: "checkbox-default"
  }, [_c('label', {
    attrs: {
      "for": "semNumeroModal"
    }
  }, [_vm._v("S/N")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.semNumero),
      expression: "semNumero"
    }],
    attrs: {
      "type": "checkbox",
      "name": "semNumeroModal",
      "id": "semNumeroModal",
      "tabindex": "-1"
    },
    domProps: {
      "checked": Array.isArray(_vm.semNumero) ? _vm._i(_vm.semNumero, null) > -1 : (_vm.semNumero)
    },
    on: {
      "change": [function($event) {
        var $$a = _vm.semNumero,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.semNumero = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.semNumero = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.semNumero = $$c
        }
      }, function($event) {
        return _vm.zeraNumero('#numeroModal')
      }]
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 col-xs-5"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "complementoModal"
    }
  }, [_vm._v("Complemento")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.enderecoEditado.complemento),
      expression: "enderecoEditado.complemento"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "complementoModal",
      "value": "",
      "id": "complementoModal"
    },
    domProps: {
      "value": (_vm.enderecoEditado.complemento)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.enderecoEditado, "complemento", $event.target.value)
      }
    }
  })])])])])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "side-footer"
  }, [_c('botao', {
    attrs: {
      "tipo": "button",
      "estilo": "cheio-cinza",
      "rotulo": "Cancelar",
      "icone": "cancela-modal"
    },
    on: {
      "clicado": function($event) {
        return _vm.cancela()
      }
    }
  }), _vm._v(" "), _c('botao', {
    attrs: {
      "tipo": "button",
      "estilo": "cheio-verde",
      "rotulo": _vm.logradouroInvalido ? 'Incluir' : 'Selecionar',
      "icone": "ok-modal"
    },
    on: {
      "clicado": function($event) {
        return _vm.inclui()
      }
    }
  })], 1)])], 2)], 1), _vm._v(" "), _c('section', {
    attrs: {
      "role": "form"
    }
  }, [_c('div', [_c('div', {
    staticClass: "row row-field"
  }, [_c('div', {
    staticClass: "col-sm-3"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "cep"
    }
  }, [_vm._v("CEP  ")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.enderecoEditado.cep),
      expression: "enderecoEditado.cep"
    }, {
      name: "mask",
      rawName: "v-mask",
      value: ('##.###-###'),
      expression: "'##.###-###'"
    }],
    staticClass: "form-control",
    class: _vm.errorInputCep,
    attrs: {
      "type": "text",
      "name": "cep",
      "value": "",
      "id": "cep",
      "disabled": _vm.disabled
    },
    domProps: {
      "value": (_vm.enderecoEditado.cep)
    },
    on: {
      "keydown": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        _vm.enderecoEditado.cep ? _vm.busca(_vm.enderecoEditado.cep) : _vm.buscaAbreModal(false)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.enderecoEditado, "cep", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-btn"
  }, [_c('botao', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip.right",
      value: ('Busca endereço'),
      expression: "'Busca endereço'",
      modifiers: {
        "right": true
      }
    }],
    staticStyle: {
      "height": "34px",
      "font-size": "12px",
      "margin-bottom": "0"
    },
    attrs: {
      "estilo": "vazado-verde-dir",
      "rotulo": "",
      "icone": "fa-search fa-lg",
      "disabled": _vm.disabled
    },
    on: {
      "clicado": function($event) {
        return _vm.busca(_vm.enderecoEditado.cep)
      }
    }
  })], 1)]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('cep')),
      expression: "errors.has('cep')"
    }],
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errors.first('cep')))])])])]), _vm._v(" "), _c('div', {
    staticClass: "row row-field"
  }, [_c('field-validation', {
    directives: [{
      name: "sem-acentos",
      rawName: "v-sem-acentos"
    }],
    attrs: {
      "css-class": "col-sm-3",
      "label": "Tipo",
      "field": "tipoLogradouro",
      "status": _vm.errors,
      "custom-errors": _vm.apiErrors,
      "show-icon": false
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.enderecoEditado.tipoLogradouro),
      expression: "enderecoEditado.tipoLogradouro"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "tipoLogradouro",
      "data-vv-as": "Tipo",
      "disabled": _vm.disabled
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.enderecoEditado, "tipoLogradouro", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    },
    domProps: {
      "selected": true
    }
  }, [_vm._v("Escolha")]), _vm._v(" "), _vm._l((_vm.tiposLogradouros), function(tipoLogradouro) {
    return _c('option', {
      key: tipoLogradouro.id,
      domProps: {
        "value": tipoLogradouro.descricao
      }
    }, [_vm._v("\n              " + _vm._s(tipoLogradouro.descricao) + "\n            ")])
  })], 2)]), _vm._v(" "), _c('field-validation', {
    attrs: {
      "css-class": "col-sm-6",
      "label": "Logradouro",
      "field": "logradouro",
      "status": _vm.errors,
      "custom-errors": _vm.apiErrors,
      "show-icon": false
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.enderecoEditado.logradouro),
      expression: "enderecoEditado.logradouro"
    }, {
      name: "sem-acentos",
      rawName: "v-sem-acentos"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|max:40'),
      expression: "'required|max:40'"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "logradouro",
      "id": "logradouro",
      "data-vv-as": "Logradouro",
      "disabled": _vm.disabled
    },
    domProps: {
      "value": (_vm.enderecoEditado.logradouro)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.enderecoEditado, "logradouro", $event.target.value)
      }
    }
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "row row-field visible-xs-12 hidden-sm hidden-md hidden-lg"
  }, [_c('field-validation', {
    attrs: {
      "css-class": "col-xs-5",
      "label": "Número",
      "field": "numero-xs",
      "status": _vm.errors,
      "custom-errors": _vm.apiErrors,
      "show-icon": false
    }
  }, [_c('input', {
    directives: [{
      name: "mask",
      rawName: "v-mask",
      value: ('#######'),
      expression: "'#######'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.enderecoEditado.numero),
      expression: "enderecoEditado.numero"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "numero-xs",
      "id": "numero-xs",
      "data-vv-as": "Número",
      "disabled": _vm.disabled
    },
    domProps: {
      "value": (_vm.enderecoEditado.numero)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.enderecoEditado, "numero", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-2"
  }, [_c('div', {
    staticClass: "checkbox-default"
  }, [_c('label', {
    attrs: {
      "for": "semNumero-xs"
    }
  }, [_vm._v("S/N")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.semNumero),
      expression: "semNumero"
    }],
    attrs: {
      "type": "checkbox",
      "name": "semNumero-xs",
      "id": "semNumero-xs",
      "tabindex": "-1",
      "disabled": _vm.disabled
    },
    domProps: {
      "checked": Array.isArray(_vm.semNumero) ? _vm._i(_vm.semNumero, null) > -1 : (_vm.semNumero)
    },
    on: {
      "change": [function($event) {
        var $$a = _vm.semNumero,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.semNumero = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.semNumero = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.semNumero = $$c
        }
      }, function($event) {
        return _vm.zeraNumero('#numero-xs')
      }]
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-5"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "complemento-xs"
    }
  }, [_vm._v("Complem.")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.enderecoEditado.complemento),
      expression: "enderecoEditado.complemento"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "complemento-xs",
      "value": "",
      "id": "complemento-xs",
      "disabled": _vm.disabled
    },
    domProps: {
      "value": (_vm.enderecoEditado.complemento)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.enderecoEditado, "complemento", $event.target.value)
      }
    }
  })])])], 1), _vm._v(" "), _c('div', {
    staticClass: "row row-field"
  }, [_c('field-validation', {
    attrs: {
      "css-class": "col-sm-3 hidden-xs",
      "label": "Complemento",
      "field": "complemento",
      "status": _vm.errors,
      "custom-errors": _vm.apiErrors,
      "show-icon": false
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.enderecoEditado.complemento),
      expression: "enderecoEditado.complemento"
    }, {
      name: "sem-acentos",
      rawName: "v-sem-acentos"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('max:15'),
      expression: "'max:15'"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "complemento",
      "id": "complemento",
      "data-vv-as": "Complemento",
      "disabled": _vm.disabled
    },
    domProps: {
      "value": (_vm.enderecoEditado.complemento)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.enderecoEditado, "complemento", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('field-validation', {
    attrs: {
      "css-class": "col-sm-3",
      "label": "Bairro",
      "field": "bairro",
      "status": _vm.errors,
      "custom-errors": _vm.apiErrors,
      "show-icon": false
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.enderecoEditado.bairro),
      expression: "enderecoEditado.bairro"
    }, {
      name: "sem-acentos",
      rawName: "v-sem-acentos"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|max:20'),
      expression: "'required|max:20'"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "bairro",
      "id": "bairro",
      "data-vv-as": "Bairro",
      "disabled": _vm.disabled
    },
    domProps: {
      "value": (_vm.enderecoEditado.bairro)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.enderecoEditado, "bairro", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('field-validation', {
    attrs: {
      "css-class": "col-sm-2 hidden-xs",
      "label": "Número",
      "field": "numero",
      "status": _vm.errors,
      "custom-errors": _vm.apiErrors,
      "show-icon": false
    }
  }, [_c('input', {
    directives: [{
      name: "mask",
      rawName: "v-mask",
      value: ('#######'),
      expression: "'#######'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.enderecoEditado.numero),
      expression: "enderecoEditado.numero"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "numero",
      "id": "numero",
      "data-vv-as": "Número",
      "disabled": _vm.disabled
    },
    domProps: {
      "value": (_vm.enderecoEditado.numero)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.enderecoEditado, "numero", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-1 hidden-xs"
  }, [_c('div', {
    staticClass: "checkbox-default"
  }, [_c('label', {
    attrs: {
      "for": "semNumero"
    }
  }, [_vm._v("S/N")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.semNumero),
      expression: "semNumero"
    }],
    attrs: {
      "type": "checkbox",
      "name": "semNumero",
      "id": "semNumero",
      "tabindex": "-1",
      "disabled": _vm.disabled
    },
    domProps: {
      "checked": Array.isArray(_vm.semNumero) ? _vm._i(_vm.semNumero, null) > -1 : (_vm.semNumero)
    },
    on: {
      "change": [function($event) {
        var $$a = _vm.semNumero,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.semNumero = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.semNumero = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.semNumero = $$c
        }
      }, function($event) {
        return _vm.zeraNumero('#numero')
      }]
    }
  })])])], 1), _vm._v(" "), _c('div', {
    staticClass: "row row-field"
  }, [_c('field-validation', {
    attrs: {
      "css-class": "col-md-4 col-sm-4",
      "label": "Estado",
      "field": "estado",
      "status": _vm.errors,
      "custom-errors": _vm.apiErrors,
      "show-icon": false
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.enderecoEditado.estado),
      expression: "enderecoEditado.estado"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "estado",
      "data-vv-as": "Estado",
      "disabled": _vm.disabled
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.enderecoEditado, "estado", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, function($event) {
        return _vm.obtemMunicipios(_vm.enderecoEditado.estado, 'formulario')
      }]
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    },
    domProps: {
      "selected": true
    }
  }, [_vm._v("Escolha")]), _vm._v(" "), _vm._l((_vm.estados), function(estado) {
    return _c('option', {
      key: estado.id,
      domProps: {
        "value": estado.sigla
      }
    }, [_vm._v("\n              " + _vm._s(_vm._f("tudoMaiusculo")(estado.nome)) + "\n            ")])
  })], 2)]), _vm._v(" "), _c('field-validation', {
    attrs: {
      "css-class": "col-md-4 col-sm-4",
      "label": "Município",
      "field": "municipio",
      "status": _vm.errors,
      "custom-errors": _vm.apiErrors,
      "show-icon": false
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.enderecoEditado.municipio),
      expression: "enderecoEditado.municipio"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "municipio",
      "data-vv-as": "Município",
      "disabled": _vm.disabled || !_vm.dadosCarregados
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.enderecoEditado, "municipio", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Escolha")]), _vm._v(" "), _vm._l((_vm.municipios), function(municipio) {
    return _c('option', {
      key: municipio.id,
      domProps: {
        "value": municipio.nome
      }
    }, [_vm._v("\n              " + _vm._s(municipio.nome) + "\n            ")])
  })], 2)])], 1)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6235ce5d","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pms-endereco-aberto-alternativo/index.vue
// module id = NGiz
// module chunks = 5